import * as AuthActions from "./authActions";

export default AuthActions;



// WEBPACK FOOTER //
// ./src/actions/AuthActions/index.js